import React from "react";
import "./CircleIcon.css";

function CircleIcon(props) {
  return (
    <div className="icon" onClick={props.onclick} style={{ cursor: "pointer" }}>
      <img
        src={props.image}
        alt=""
        style={{ objectFit: "contain", width: "100%", height: "100%" }}
      />
    </div>
  );
}
export default CircleIcon;
